import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowDownCircle } from "lucide-react";
import { formatBillingAmount } from "./_shared";

function PlanOptionCard({ plan, tenantCurrency, currentPlanId, currentPlanOrder, idx, onChoose, changing, t }) {
  const isCurrent = plan.plan_id === currentPlanId;
  const isUpgrade = idx > currentPlanOrder;
  return (
    <div
      data-testid={`change-to-${plan.plan_id}`}
      className={`rounded-2xl p-5 border-2 ${
        isCurrent ? "border-emerald-500 bg-emerald-50" : "border-eh-border-soft bg-white hover:border-sol-gold/50"
      }`}
    >
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-sol font-semibold text-lg">{plan.name}</h3>
        {isCurrent && <span className="text-xs text-emerald-700 font-medium">{t("bill.currentPlan")}</span>}
      </div>
      <div className="text-2xl font-semibold mb-2">
        {formatBillingAmount(plan.prices?.[tenantCurrency], tenantCurrency)}
        <span className="text-xs text-eh-muted">{t("bill.perMonth")}</span>
      </div>
      <p className="text-xs text-eh-muted mb-3">{plan.tagline}</p>
      <Button
        onClick={() => onChoose(plan.plan_id)}
        disabled={isCurrent || changing}
        data-testid={`confirm-change-${plan.plan_id}`}
        size="sm"
        className={isUpgrade ? "bg-sol-gold text-sol-midnight hover:bg-sol-gold/90" : "bg-eh-ink text-eh-bg"}
      >
        {isCurrent ? t("bill.planActive") : isUpgrade ? t("bill.upgradeTo") : <><ArrowDownCircle className="w-4 h-4 mr-1" /> {t("bill.downgrade")}</>}
      </Button>
    </div>
  );
}

export default function ChangePlanModal({ open, onClose, plans, tenant, onChoose, changing, t }) {
  if (!open) return null;
  const currentPlanOrder = plans.findIndex((p) => p.plan_id === tenant.plan_id);

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" onClick={onClose}>
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-3xl p-8 max-w-3xl w-full max-h-[90vh] overflow-y-auto"
        data-testid="plan-modal"
      >
        <h2 className="font-display text-2xl mb-2">{t("bill.changePlanTitle")}</h2>
        <p className="text-eh-muted text-sm mb-6">{t("bill.changePlanSub")}</p>
        <div className="grid sm:grid-cols-2 gap-4">
          {plans.map((p, idx) => (
            <PlanOptionCard
              key={p.plan_id}
              plan={p}
              tenantCurrency={tenant.currency}
              currentPlanId={tenant.plan_id}
              currentPlanOrder={currentPlanOrder}
              idx={idx}
              onChoose={onChoose}
              changing={changing}
              t={t}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
